// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230435/js/" + chunkId + "." + {"44":"9b098be8","225":"e8ad0adf","481":"758a83c8","486":"4f467742","770":"dbbe0ee0"}[chunkId] + ".0.20537816543918286.chunk.js";
};